import { l as _inherits, h as _createClass, i as _classCallCheck, m as _callSuper } from './_rollupPluginBabelHelpers-e71b1aad.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import LazyImage from './LazyImage.js';
import Modal from './Modal.js';
import { I as Icon } from './index-11bc5ac3.js';
import PhotoGallery from './PhotoGallery.js';
import { d as defaultImage } from './general-2a8d8650.js';
import { r as roomInfoShape, i as intlShape } from './PropTypes-e1e509ba.js';
import './index-f5c6df27.js';
import './_commonjsHelpers-17042db9.js';
import 'react-dom';
import './ModalHeader-77a50105.js';
import './Title.js';
import './tslib.es6-2748fcb6.js';
import 'moment';
import 'react-slick';
import './Image.js';
import './Label.js';
import './message-f222f616.js';
import './useIntl-2a91ee7b.js';
import './injectIntl-d3879c1a.js';
import './hoist-non-react-statics.cjs-50d12f04.js';

var RoomDetailsModal = /*#__PURE__*/function (_React$Component) {
  function RoomDetailsModal(props) {
    var _this;
    _classCallCheck(this, RoomDetailsModal);
    _this = _callSuper(this, RoomDetailsModal, [props]);
    _this.handleOpen = _this.handleOpen.bind(_this);
    return _this;
  }
  _inherits(RoomDetailsModal, _React$Component);
  return _createClass(RoomDetailsModal, [{
    key: "handleOpen",
    value: function handleOpen() {
      var openHandler = this.props.openHandler;
      openHandler();
    }
  }, {
    key: "render",
    value: function render() {
      var _mainImage$url,
        _this2 = this,
        _mainImage;
      var _this$props = this.props,
        roomInfo = _this$props.roomInfo,
        hasUncroppedImages = _this$props.hasUncroppedImages,
        useEagerLoading = _this$props.useEagerLoading,
        intl = _this$props.intl;
      var title = roomInfo.title;
      var images = roomInfo.images,
        mainImage = roomInfo.mainImage;
      if (!images || !Array.isArray(images) || images.length === 0) {
        images = [{
          title: '',
          url: defaultImage
        }];
      }
      if (!mainImage) {
        mainImage = images[0];
      }
      var IMAGE_WIDTH = 485;
      var IMAGE_HEIGHT = 273;
      var hasImage = ((_mainImage$url = mainImage.url) === null || _mainImage$url === void 0 ? void 0 : _mainImage$url.length) > 0 && mainImage.url !== defaultImage;
      var altText = mainImage.description || intl.formatMessage({
        id: 'bf.openImageGallery',
        defaultMessage: 'bf.openImageGallery'
      });
      var trigger = function trigger() {
        return images && Array.isArray(images) && images.length > 0 ? /*#__PURE__*/React__default.createElement("div", {
          onClick: _this2.handleOpen,
          className: "room-details-modal-trigger"
        }, /*#__PURE__*/React__default.createElement(LazyImage, {
          alt: altText,
          src: mainImage.url,
          fluid: true,
          blurred: true,
          nolazy: useEagerLoading,
          width: IMAGE_WIDTH,
          height: IMAGE_HEIGHT
        }), images && Array.isArray(images) && images.length > 1 ? /*#__PURE__*/React__default.createElement("div", {
          className: "gallery-images-count"
        }, /*#__PURE__*/React__default.createElement(Icon, {
          name: "bf-icon-image"
        }), "".concat(images.length)) : null) : null;
      };
      return hasImage ? /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Modal, {
        title: title,
        trigger: trigger(),
        content: /*#__PURE__*/React__default.createElement(PhotoGallery, {
          thumbsEnabled: true,
          images: images,
          hasUncroppedImages: hasUncroppedImages,
          intl: intl
        }),
        onOpen: this.handleOpen,
        className: "room-details-modal"
      })) : /*#__PURE__*/React__default.createElement(LazyImage, {
        alt: intl.formatMessage({
          id: 'bf.defaultImage',
          defaultMessage: 'bf.defaultImage'
        }),
        src: (_mainImage = mainImage) === null || _mainImage === void 0 ? void 0 : _mainImage.url,
        fluid: true,
        blurred: true,
        nolazy: useEagerLoading,
        width: IMAGE_WIDTH,
        height: IMAGE_HEIGHT
      });
    }
  }]);
}(React__default.Component);
RoomDetailsModal.defaultProps = {
  hasUncroppedImages: false,
  openHandler: function openHandler() {},
  roomInfo: null,
  useEagerLoading: false
};
RoomDetailsModal.propTypes = {
  roomInfo: PropTypes.shape(roomInfoShape),
  hasUncroppedImages: PropTypes.bool,
  openHandler: PropTypes.func,
  useEagerLoading: PropTypes.bool,
  intl: PropTypes.shape(intlShape).isRequired
};

export default RoomDetailsModal;
//# sourceMappingURL=RoomDetailsModal.js.map
